import { makeStyles } from 'tss-react/mui'

export const truncateStyles = makeStyles()((theme) => {
  return {
    more: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  }
})
